<p><strong>{{countryName}} comments ({{events.length}})</strong></p>

<form name="timelineCommentForm" [formGroup]="timelineCommentForm" novalidate>
    <div class="form-group comment-form">
        <textarea class="form-control" formControlName="comment" ></textarea>
        <button type="submit" class="btn btn-primary btn-sm mt-3" (click)="post(timelineCommentForm.value)" [disabled]="timelineCommentForm.controls['comment'].value.length === 0">Add comment</button>
    </div>
</form>
<div class="events ml-md-3">
	<div class="event" [ngClass]="{'event-highlight' : event.type !== 'CountryDataTimelineComment'}" *ngFor="let event of events">
		
		<small class="ellipsis">
			<strong>
				<ng-container *ngIf="event.type == 'CountryDataTimelineDraftEvent'">
					<span>Draft <span class="text-info">created <i class="fa fa-plus"></i></span></span>
				</ng-container>
				<ng-container *ngIf="event.type == 'CountryDataTimelineApprovalEvent'">
					<span>Content <span class="text-success">approved <i class="fa fa-check"></i></span></span>
				</ng-container>
				<ng-container *ngIf="event.type == 'CountryDataTimelineRejectionEvent'">
					<span>Content <span class="text-danger">rejected <i class="fa fa-close"></i></span></span>
				</ng-container>
			</strong>
			<span *ngIf="event.workflowStageName" class="ml-2 text-muted"> 		
				({{event?.workflowStageName}})
			</span>
		</small>
		
		<p class="event-text" *ngIf="event?.comment">{{event?.comment}}</p>
		
		<small class="text-muted ellipsis" title="{{event?.workflowStageName}}">
			<em>{{event?.createdDate | fromnow}}, by</em>
			<strong class="text-info">{{event?.createdBy}}
			</strong>
		</small>
	</div>
</div>